/** M / F / O plus optional age for tickets table. */
export function genderAbbrev(raw) {
  const s = String(raw || '').trim().toLowerCase();
  if (!s) return '—';
  if (s === 'male' || s === 'm') return 'M';
  if (s === 'female' || s === 'f') return 'F';
  if (s === 'other' || s === 'o') return 'O';
  return s.charAt(0).toUpperCase();
}

export function ageYearsFromBirthdate(birthdate) {
  if (!birthdate) return null;
  const raw = String(birthdate).trim();
  const d = raw.length >= 10 ? new Date(`${raw.slice(0, 10)}T12:00:00`) : new Date(raw);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  if (age < 0 || age > 130) return null;
  return age;
}

/** Display gender letter + age for tickets table cell. */
export function formatTicketGenderAge(genderRaw, birthdate) {
  const gender = genderAbbrev(genderRaw);
  const age = ageYearsFromBirthdate(birthdate);
  return { gender, age };
}
